import type { Signer } from "../types/signing";

export const addApplicantEmailToSigners = (
	signers: Signer[],
	applicantId: string,
	applicantEmail: string | null,
): Signer[] =>
	signers.map((signer) => {
		if (signer.nationalId === applicantId) {
			return { ...signer, email: applicantEmail };
		}
		return { ...signer };
	});
